import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhile, concatMap } from 'rxjs';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AuthService } from 'src/app/services/auth.service';
import { CareerService } from 'src/app/services/career.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss']
})
export class JobDetailsComponent implements OnInit, OnDestroy {
  jobPost: any;
  applicantId: any;
  countries!: any[];
  salaryHide: boolean = false;
  companyDetailsHide: boolean = false;
  jobPostId: any;
  viewAllJobs: boolean = false;
  jobStatus: any;
  currentPage: number = 0;
  previousAllJobsFilterForm: any;
  isJobSaved: boolean = false;
  userId: any;

  showSharePopup: boolean = false;
  currentUrl: string = '';

  constructor(private readonly careerService: CareerService, private route: ActivatedRoute, private readonly router: Router,
    private readonly masterDataService: MasterDataService, private readonly endCustomerService: EndCustomerService,
    private readonly localStorageService: LocalStorageService,
    private swalService: SweetAlertService,
    private snackbarService: SnackbarService, private authService: AuthService) {
    this.jobPostId = this.route.snapshot.paramMap.get('id');
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state?.['currentPage']) {
      this.currentPage = navigation?.extras.state?.['currentPage'];
    }
  }

  ngOnInit(): void {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.currentUrl = window.location.href;
    this.route.params.subscribe(params => {
      const jobPostIdFromUrl = params['id'];
      this.getJobPostById(jobPostIdFromUrl);
    });
    this.loadCountries('');
    this.localStorageService.getUserDetails().subscribe(data => {
      this.userId = data?.userId;
      this.getEndCustomerByUserId(data?.userId);
    });

    this.viewAllJobs = window.history?.state.viewAllJobs
    this.jobStatus = window.history?.state.jobStatus
    this.isJobSaved = window.history?.state.isJobSaved
    this.previousAllJobsFilterForm = window.history?.state.previousFilterForm;
    window.addEventListener('popstate', this.onPopState.bind(this));
    if (localStorage.getItem('postLoginJobApply')) {
      localStorage.removeItem('postLoginJobApply');
    }
  }

  private getJobPostById(jobPostId: any) {
   
    
    this.jobPost = {};
    this.careerService.executeGetRequestURL(MweConstants.getJobPostUrl.concat('/', jobPostId), null).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          const jobPostResponse = response?.data;
          this.companyDetailsHide = jobPostResponse.postAnonymously;
          this.salaryHide = jobPostResponse.hideSalary;
          jobPostResponse.skills = this.convertStringToArray(jobPostResponse.skills);
          jobPostResponse.tags = this.convertStringToArray(jobPostResponse.tags)
          this.jobPost = jobPostResponse;
        }
      }, error: (error: any) => {
      }
    });
  }

  private convertStringToArray(field: any) {
    return (field !== undefined && field !== null && field.length > 0) ? field.split(",") : [];
  }

  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
      });
  }
  onPopState(event: PopStateEvent): void {
    this.onBack();
  }

  onBack() {
    const isPostLoginApply = localStorage.getItem('postLoginJobApply') === 'true';

    if (!isPostLoginApply) {
      const navigationState = {
        backToSavedJobs: this.jobStatus === 'savedJobs',
        backToAppliedJobs: this.jobStatus === 'appliedJobs'
      };

      if (navigationState.backToSavedJobs || navigationState.backToAppliedJobs) {
        this.router.navigate(['/user/home'], { state: navigationState });
      } else {
        this.routeTOBack();
      }
    } else {
      this.routeTOBack();
    }

  }
  routeTOBack(){
    this.router.navigate(['/jobs/view-all-jobs'], {
      queryParams: { page: this.currentPage },
      state: { prevFilter: true, previousFilterForm: this.previousAllJobsFilterForm }
    });
  }

  roleName:boolean = false;
  onApplyJob(jobPostId: any) {
    if (!this.userId) {
      this.authService.setLastVisitedUrl(this.router.url);
      localStorage.setItem('postLoginJobApply', 'true');
     Swal.fire({
                       iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
                       iconColor: '#ffffff',
                       title: '<strong>Log in to apply for this job</strong>',
                       showCancelButton: true,
                       confirmButtonText: 'Login',
                       cancelButtonText: 'Cancel',
                       html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? <a href="/user/signup" style="color: blue;font-size: 16px;font-weight: 600; text-decoration: underline;text-wrap:nowrap">Join Now</a></p>`,
                       focusConfirm: false
                     }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/login']);
        }
      });
      return;
    }
    const roleName = localStorage.getItem('roleName') ?? '';
    this.roleName = roleName === 'SUPER_ADMIN';
    if (!this.roleName) {
      this.careerService.setJobId(jobPostId);
      this.router.navigate(['../../job-apply', jobPostId], { relativeTo: this.route });
    } else {
      this.swalService.showError('', 'You cannot apply for jobs');
    }
  }

  getCurrencySymbol(currency: string | undefined): string {
    if (!currency || !this.countries) {
      return '';
    }

    const country = this.countries.find(country => country.currency === currency);

    if (country && country.currencySymbol) {
      return country.currencySymbol;
    }

    return '';
  }

  getEndCustomerByUserId(userId: any) {
    this.endCustomerService.executeGetRequestURL(MweConstants.getCustomerByUserId + userId, null).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          this.applicantId = response?.data.id;

        }
      }, error: (error: any) => {

      }
    });
  }
  isApplicationClosed(applicationCloseDate: any): boolean {
    const closeDate = new Date(applicationCloseDate);
    const closeTime = new Date(applicationCloseDate);
    closeTime.setHours(23, 59, 59, 0);
    closeDate.setTime(closeTime.getTime());
    const currentDate = new Date();
    return closeDate <= currentDate;
  }

  onSaveJob(jobPost: any) {
    if (!this.userId) {
      this.swalService.showError('', 'Please login to save job');
      return;
    }
    const body = {
        jobApplicantKey: {
            jobPostId: jobPost.id,
            applicantId: this.applicantId
        },
        userId: this.userId
    };
    if (this.isJobSaved) {
      this.careerService.executeDeleteRequestURL(MweConstants.deleteJobPostUrl.concat(`applicant/${this.applicantId}/jobs/${jobPost.id}`), null, null).subscribe({
        next: () => {
          this.isJobSaved = false;
          this.updateHistoryState();
          Swal.fire('', 'Job unsaved successfully.', 'success');
        }, error: (error: any) => {
          Swal.fire('', 'You are not Authorized to perform this action', 'error');
        }
      });
    } else {
      this.careerService.executePostRequest(MweConstants.getJobPostUrl.concat("/applicant/jobs"), body).subscribe({
        next: () => {
          this.isJobSaved = true;
          this.updateHistoryState();
          Swal.fire('', 'Job saved successfully.', 'success');
        },
        error: (error: any) => {
          Swal.fire('', error.error.message.includes("Duplicate Record") ? 'To unsave the job, please go to " Saved Jobs " !' : 'You are not Authorized to perform this action', 'error');
        }
      });
    }
  }
  private updateHistoryState(): void {
    window.history.replaceState(
      { ...window.history.state, isJobSaved: this.isJobSaved }, ''
    );
  }

  onShareJob(): void {
    this.showSharePopup = true;
  }

  closeSharePopup(): void {
    this.showSharePopup = false;
  }

  copyUrl(): void {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      Swal.fire('', 'Link copied to clipboard!', 'success');
      this.closeSharePopup();
    }).catch(() => {
      Swal.fire('', 'Failed to copy link', 'error');
      this.closeSharePopup();
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.onPopState.bind(this));
    this.careerService.setJobId(null);
  }
}
